async function getQty(vId, update) {
  const response = await fetch(window.Shopify.routes.root + 'cart.js');
  const data = await response.json();
  let totalQty = (data.items.find(item => item.variant_id === vId) || {}).quantity || 0;
  let change = false;
  if (totalQty > 0) {
    if (update == 'plus') {
      totalQty += 1;
      change = true;
    } else if (update == 'minus' && totalQty > 1) {
      totalQty -= 1;
      change = true;
    }

    const responseData = { 
      "qty": totalQty,
      "change": change
    }
    return responseData;
  } else {
    return null;
  }
}

async function updateCart(vId, update) {
  let qty = null;
  let change = false;
  if (update == 'remove') {
    qty = 0;
    change = true;
  } else {
    responseData = await getQty(vId, update);
    qty = responseData.qty;
    change = responseData.change;
  }
  
  if (qty != null && change) {
    const updates = {
      [vId]: qty
    };

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => response.json())
    .then(data => {
      renderCart();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}
var settingsId = $('#getRelated_prd').attr('productid');
async function renderCart() {
  $('.add-cart-text').removeClass('hide');
  $('span[data-loader]').addClass('hide');
  $('.product-form__cart-submit').removeAttr('aria-disabled');
  $.ajax({
    url: '/?section_id=cart-drawer',
    type: 'GET',
    dataType: 'html',
    success: function(carthtml) {
      const currentPopupTarget = document.querySelector('.drawer__wrapper .tax-exempt-popup-target');
      const preservedPopupNodes = currentPopupTarget ? Array.from(currentPopupTarget.childNodes) : [];
      const newContent = $(carthtml).find('.drawer__wrapper').html();
      $('.drawer__wrapper').html(newContent);
      if (preservedPopupNodes.length) {
        const refreshedPopupTarget = document.querySelector('.drawer__wrapper .tax-exempt-popup-target');
        if (refreshedPopupTarget && !refreshedPopupTarget.hasChildNodes()) {
          preservedPopupNodes.forEach((node) => refreshedPopupTarget.appendChild(node));
        }
      }
      attachDrawerEvents(); // Reattach event listeners after content update
      const productId = $('#CartDrawer-Item-1').attr('productId');
      if(productId){
         getRecommendedProducts(productId);
      }else if(settingsId){
           getRecommendedProducts(settingsId);
      }
      return true;
    },
    error: function(xhr, status, error) {
      console.error('Error loading cart drawer:', error);
    }
  });
}

async function getRecommendedProducts(productId){
  const container = document.getElementById('custom_recommended_cart');       
  container.innerHTML = '';
  function pseudoCamelCase(str) {
  return str
    .replace(/[^a-zA-Z0-9 ]/g, '') 
    .split(' ')
    .map((word, index) =>
      index === 0
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(' ');
}

fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${productId}&limit=4&intent=related`)
  .then(response => response.json())
  .then(({ products }) => {
    if (products.length > 0) {
      let productHTML = '';
      products.forEach(product => {
        productHTML += `
          <div class="recommended-product">
            <a href="${product.url}">
              <img 
                src="${product.featured_image.startsWith('//') ? 'https:' + product.featured_image : product.featured_image}&width=400" 
                alt="${product.title}" 
                style="width: 100%; max-width: 300px;" 
              />
              <h3>${pseudoCamelCase(
    product.title.length > 22
      ? product.title.substring(0, 22) + "..."
      : product.title
  )}</h3>
            </a>
            <div class="cart_btn_wrap">
            <button class="recommend_cart" onclick="addToCart('${product.variants[0].id}')">
            <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 21" fill="none">
<path d="M9.97461 6.80923V14.1563" stroke="white"/>
<path d="M13.6484 10.4767L6.30137 10.4767" stroke="white"/>
<circle cx="9.97382" cy="10.4828" r="9.29609" stroke="white"/>
</svg></span>
              <p>$${(product.price / 100).toFixed(2)}</p>
            </button>
            </div>
          </div>
        `;
      });
      container.innerHTML = productHTML;
    }
    return true;
  })
  .catch(error => {
    console.error('Error:', error);
  });
  
}


async function addToCart(vId){
              let formData = {
                    id: vId,
                    quantity: 1
                };
                $.ajax({
                   url: '/cart/add',
                   type: 'POST',
                   data: formData,
                  success: function(response){
                       renderCart();
                  }
                });
}
// ⬇️ Reusable function to attach event listeners
function attachDrawerEvents() {
  const drawerEl = document.querySelector('.drawer');
  if (!drawerEl) return;
  
  const wrapper = drawerEl.querySelector('.drawer__wrapper');
  const closeBtn = drawerEl.querySelector('.drawer__close');
  const overlay = drawerEl.querySelector('.drawer__overlay');
  const openBtn = document.querySelector('.cart___drawer');
  function openDrawer() {
    drawerEl.classList.add('is-active');
    setTimeout(() => drawerEl.classList.add('is-visible'), 2);
    renderCart();
    return true;
  }
$('.bndlr-add-to-cart').on('click', function() {
  openDrawer();
});
  function closeDrawer() {
    drawerEl.classList.remove('is-visible');
    setTimeout(() => drawerEl.classList.remove('is-active'), 300);
  }
  if (openBtn) {
    openBtn.addEventListener('click', openDrawer);
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }
  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }
  document.addEventListener('click', (e) => {
    if (
      drawerEl.classList.contains('is-visible') &&
      !wrapper.contains(e.target) &&
      !openBtn.contains(e.target)
    ) {
      closeDrawer();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawerEl.classList.contains('is-visible')) {
      closeDrawer();
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const drawerEl = document.querySelector('.drawer');
$('.product-form__cart-submit').off('click').on('click', function () {
  setTimeout(() => {
    renderCart();
    drawerEl.classList.add('is-active');
    setTimeout(() => drawerEl.classList.add('is-visible'), 10);
  }, 2000);
});

  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json());
     attachDrawerEvents();
      setTimeout(() => {
  attachDrawerEvents(); // Initial event binding
    }, 4000);
});
